import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Navigation from '../../components/navigation.components';
import { withOktaAuth } from '@okta/okta-react';

import { Button, Modal, Accordion } from 'react-bootstrap';

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus, faTrash, faPen } from '@fortawesome/free-solid-svg-icons'

class Categories extends Component {

	state = {
		page: {
			loaded: true
		},
		api: {
			categories: []
		},
		formData: {
			emapta: true,
			name: "",
			description: "",
			require_attachment: false,
			subcategories: []
		},
		withSubcategories: false,
		formErrors: [],
		modal: {
			create: false,
			delete: false,
		},
		formStatus: {
			submitted: false
		},
		selected: {
			delete: null
		}
	}

	componentDidMount() {
		this.getAllCategories();
	}

	getAllCategories = async e => {
		let { page, api } = { ...this.state };
		let request = await axios.get('/api/categories');
		let { data } = request.data
		api.categories = data;
		page.loaded = true;
		this.setState({ ...this.state, api, page });

	}

	submitNewCategory = e => {
		e.preventDefault();
		let { formData, formErrors, withSubcategories, formStatus } = this.state;
		let requiredFields = ['name'];
		formErrors = [];

		if (!withSubcategories) {
			requiredFields = ['name'];
		} else {
			requiredFields = ['name'];

			if (formData.subcategories.length > 0) {
				formData.subcategories.map((category, idx) => {
					if (category.name.trim() === "" && !formErrors.includes('name_' + idx)) {
						formErrors.push('name_' + idx);
					}
					// if (category.recipients.trim() === "" && !formErrors.includes('recipients_' + idx)) {
					// 	formErrors.push('recipients_' + idx);
					// }
				})
			}
		}

		requiredFields.map(field => {
			if (formData[field].length < 1 || formErrors.length === "") {
				formErrors.push(field);
			}
		})


		if (formErrors.length < 1) {
			formStatus.submitted = true;
			this.setState({ ...this.state, formErrors, formData, formStatus }, () => {

				if (formData.hasOwnProperty('id')) {
					this.updateCategoryRequest();
				} else {
					this.saveNewCategoryRequest();
				}
			});
		} else {
			this.setState({ ...this.state, formErrors, formData });
		}

	}

	updateCategoryRequest = e => {
		let { formData, withSubcategories } = { ...this.state };
		let data = { ...formData, withSubcategory: withSubcategories };
		axios.put(`/api/categories/${formData.id}`, data,
			{
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('access-token')
				}
			})
			.then(response => {
				let { formStatus, modal, formData, page, withSubcategories } = { ...this.state };
				formStatus.submitted = false;
				page.loaded = true;
				modal.create = false;
				withSubcategories = false;
				formData = {
					name: "",
					description: "",
					// recipients: "",
					subcategories: []
				}
				page.loaded = false;
				this.setState({ ...this.state, formStatus, formData, modal, formData, page, withSubcategories }, () => {
					this.getAllCategories();
					toast.success('Successfully created category', {
						position: "bottom-left",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					});
				})
			})
			.catch(error => {
				let { formStatus, formData } = { ...this.state };
				formStatus.submitted = false;

				this.setState({ ...this.state, formStatus, formData }, () => {
					toast.error(error.response.data.errors, {
						position: "bottom-left",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					});
				})
			})
	}

	withSubcategoriesHandler = e => {
		let { formData, withSubcategories, formErrors } = { ...this.state };
		// formData.recipients = "";
		formErrors = [];
		if (e.target.checked) {
			formData.subcategories = [
				{
					name: '',
					require_attachment: false
				}
			];
		} else {
			formData.subcategories = [];
		}

		// if (formErrors.includes('recipients')) {
		// 	let idx = formErrors.indexOf('recipients');
		// 	formErrors.splice(idx, 1);
		// }

		withSubcategories = e.target.checked;

		this.setState({ ...this.state, formData, withSubcategories, formErrors });
	}

	changeInputHandler = e => {
		let { formData, formErrors } = { ...this.state };
		formData[e.target.name] = e.target.value;
		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		if (e.target.name === "emapta") {
			formData[e.target.name] = e.target.checked;
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	closeCreateCategory = e => {
		// e.hasOwnProperty('preventDefault') && e.preventDefault();
		let { modal, formData, withSubcategories } = { ...this.state };
		modal.create = false;
		withSubcategories = false;
		formData = {
			emapta: true,
			name: "",
			description: "",
			// recipients: "",
			subcategories: []
		}
		this.setState({ ...this.state, modal, formData, withSubcategories }, () => this.getAllCategories());
	}

	addNewCategoryModal = e => {
		e.preventDefault();
		let { modal, formErrors } = { ...this.state };
		modal.create = true;
		formErrors = [];
		this.setState({ ...this.state, modal, formErrors });
	}

	subCategoryChangeHandler = (e, idx) => {
		let formData = { ...this.state.formData };

		if (e.target.name === "name") {
			formData.subcategories[idx][e.target.name] = e.target.value;
		}

		if (e.target.name === "require_attachment") {
			formData.subcategories[idx][e.target.name] = e.target.checked;
		}
		this.setState({ ...this.state, formData });
	}

	addNewSubCategoryHandler = e => {
		e.preventDefault();
		let formData = this.state.formData;
		formData.subcategories.push({
			name: '',
			require_attachment: false
		})

		this.setState({ ...this.state, formData });
	}

	removeSubcategoryHandler = (e, idx) => {
		e.preventDefault();
		let formData = this.state.formData;
		formData.subcategories.splice(idx, 1);
		this.setState({ ...this.state, formData });
	}

	saveNewCategoryRequest = () => {
		let { formData, withSubcategories } = { ...this.state };
		let data = { ...formData, withSubcategory: withSubcategories };
		axios.post('/api/categories', data,
			{
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('access-token')
				}
			})
			.then(response => {
				let { formStatus, modal, formData, page, withSubcategories } = { ...this.state };
				formStatus.submitted = false;
				page.loaded = true;
				modal.create = false;
				withSubcategories = false;
				formData = {
					emapta: true,
					name: "",
					description: "",
					// recipients: "",
					subcategories: []
				}
				page.loaded = false;
				this.setState({ ...this.state, formStatus, formData, modal, formData, page, withSubcategories }, () => {
					this.getAllCategories();
					toast.success('Successfully created category', {
						position: "bottom-left",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					});
				})
			})
			.catch(error => {
				let { formStatus, formData } = { ...this.state };
				formStatus.submitted = false;

				this.setState({ ...this.state, formStatus, formData }, () => {
					toast.error(error.response.data.errors, {
						position: "bottom-left",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					});
				})
			})
	}

	// Delete
	removeCategoryRequest = (e, category) => {
		let { selected, modal } = { ...this.state };
		selected.delete = category;
		modal.delete = true;
		this.setState({ ...this.state, selected, modal });
	}

	closeDeleteCategory = e => {
		let { selected, modal } = { ...this.state };
		selected.delete = null;
		modal.delete = false;
		this.setState({ ...this.state, selected, modal });
	}

	submitDeleteRequest = async e => {
		let { selected, formStatus, modal, page } = { ...this.state };
		formStatus.submitted = true;
		page.loaded = false;
		axios.delete(`/api/categories/${selected.delete._id}`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access-token')
			}
		}).then(response => {
			selected.delete = null;
			formStatus.submitted = false;
			modal.delete = false;
			this.setState({ ...this.state, selected, formStatus, modal, page }, () => {
				toast.success('Successfully Deleted category', {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

				this.getAllCategories();
			});
		}).catch(err => {
			toast.error('Something went wrong!', {
				position: "bottom-left",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
			});
		})

	}

	updateCategoryHandler = (e, category) => {
		e.preventDefault();
		let { modal, formData, withSubcategories } = this.state;
		formData.id = category._id;
		formData.name = category.name;
		formData.description = category.description;
		// formData.recipients = category.recipients;
		formData.subcategories = category.subcategories;
		formData.emapta = category.emapta;
		if (category.subcategories.length > 0) {
			withSubcategories = true;
		}

		modal.create = true;

		this.setState({ ...this.state, modal, formData, withSubcategories });
	}

	render() {
		let { page, formData, formErrors, modal, formStatus, api } = this.state;

		let lastSubcategory = 0;
		if (formData.subcategories.length > 1) {
			lastSubcategory = formData.subcategories.length - 1;
		}

		return <>
			<Navigation />
			<ToastContainer
				position="bottom-left"
				autoClose={5000}
				hideProgressBar={true}
				newestOnTop={true}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable={false}
				pauseOnHover
			/>
			{page.loaded ?
				<div className='container'>
					<div className='row mt-3'>
						<div className='col-12 text-right'>
							<Button variant="primary" style={{ float: 'right' }} onClick={e => this.addNewCategoryModal(e)}>Create Category</Button>
						</div>
					</div>

					<div className='row mt-3'>
						<div className='col-12 '>
							<Accordion>
								{api.categories.map((category, idx) =>
									<Accordion.Item key={category._id} eventKey={idx}>
										<Accordion.Header>
											<div className='row'>
												<div className='col-12' style={{ textTransform: 'capitalize' }}>{category.name}</div>
												<div className='col-12 text-muted'>{category.emapta ? "Emapta Employees" : "Non Emapta Employees"}</div>
												<div className='col-12 text-muted'>{category.subcategories.length > 0 && `${category.subcategories.length} Subcategories `}</div>
											</div>
										</Accordion.Header>
										<Accordion.Body>
											{category.subcategories.length > 0 ?
												<div className="row">
													<div className="col-12">
														<p>
															<strong>Type: </strong> {category.emapta ? "Emapta Employees" : "Non Emapta Employees"} <br />
															<strong>Category: </strong> {category.name} <br />
															<strong>Description: </strong> {category.description} <br /><br />

															{/* {category.subcategories.length < 1 &&
																<>
																	<strong>Recipients: </strong><br />
																	{category.recipients}
																</>
															} */}

														</p>
													</div>

													{category.subcategories.length > 0 && <div className='col-12'><h6>Subcategories</h6></div>}
													{category.subcategories.length > 0 && category.subcategories.map((subcat, idx) =>
														<div className="col-12" key={idx}>
															<h6>{subcat.name} {subcat.require_attachment && <i>(Require attachment)</i>}</h6>
														</div>
													)}

													<div className="col-12">
														<div style={{ float: "right" }}>
															<button
																type="button"
																className="btn btn-danger btn-sm "
																onClick={e => this.removeCategoryRequest(e, category)}
																disabled={formStatus.submitted}
															>
																<FontAwesomeIcon icon={faTrash} /> Delete
															</button> &nbsp;
															<button
																type="button"
																className="btn btn-info btn-sm "
																onClick={e => this.updateCategoryHandler(e, category)}
																disabled={formStatus.submitted}
															>
																<FontAwesomeIcon icon={faPen} /> Update
															</button>
														</div>

													</div>

												</div>
												:
												<div className="row">

													<div className="col-12">
														<p>
															<strong>Type: </strong> {category.emapta ? "Emapta Employees" : "Non Emapta Employees"} <br />
															<strong>Category: </strong> {category.name} <br />
															<strong>Description: </strong> {category.description} <br /><br />
															{category.require_attachment && <strong>Require attachment </strong>}
														</p>
													</div>

													<div className="col-12">
														<div style={{ float: "right" }}>
															<button
																type="button"
																className="btn btn-danger btn-sm "
																onClick={e => this.removeCategoryRequest(e, category)}
																disabled={formStatus.submitted}
															>
																<FontAwesomeIcon icon={faTrash} /> Delete
															</button> &nbsp;
															<button
																type="button"

																className="btn btn-info btn-sm "
																onClick={e => this.updateCategoryHandler(e, category)}
																disabled={formStatus.submitted}
															>
																<FontAwesomeIcon icon={faPen} /> Update
															</button>
														</div>

													</div>
												</div>
											}
										</Accordion.Body>
									</Accordion.Item>
								)}
							</Accordion>
						</div>
					</div>
					{/* Create Modal */}
					<Modal
						show={modal.create}
						size="lg"
						onHide={e => this.closeCreateCategory(e)}
						backdrop="static"
						keyboard={false}
					>
						<Modal.Header closeButton={!formStatus.submitted}>
							<Modal.Title>{formData.hasOwnProperty('id') ? "Update" : "Create"} Category</Modal.Title>
						</Modal.Header>
						<Modal.Body>

							<form>

								<div className='mb-3 form-check'>
									<input
										className="form-check-input"
										type="checkbox"
										checked={formData.emapta}
										id="emaptaEmployee"
										name="emapta"
										value={formData.emapta}
										onChange={e => this.changeInputHandler(e)}
										disabled={formStatus.submitted}
									/>
									<label className="form-check-label" htmlFor="emaptaEmployee">
										Emapta Employees?
									</label>
								</div>

								<div className="mb-3">
									<label htmlFor='category ' className='form-label'>Category *</label>
									<input
										type="text"
										name="name"
										id="name"
										onChange={e => this.changeInputHandler(e)}
										value={formData.name}
										className={`form-control ${formErrors.includes('name') ? 'is-invalid' : ''}`}
										disabled={formStatus.submitted}
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='description'>Description</label>
									<textarea
										name="description"
										className='form-control'
										id="description"
										cols={64}
										rows={2}
										style={{ resize: 'none' }}
										value={formData.description}
										onChange={e => this.changeInputHandler(e)}
										disabled={formStatus.submitted}
									/>
								</div>
								<div className='mb-3 form-check'>
									<input
										className="form-check-input"
										type="checkbox"
										checked={this.state.withSubcategories}
										id="withSubcategories"
										onChange={e => this.withSubcategoriesHandler(e)}
										disabled={formStatus.submitted}
									/>
									<label className="form-check-label" htmlFor="withSubcategories">
										Add sub category
									</label>
								</div>

								{this.state.withSubcategories &&
									<>
										<h5 className='mb-5'>Subcategories</h5>
										{formData.subcategories.map((category, idx) => {
											return <Fragment key={idx}>
												<div className="mb-3">
													<input
														type="text"
														name={'name'}
														id={'name'}
														value={formData.subcategories[idx].name}
														placeholder="Subcategory type"
														className={`form-control ${formErrors.includes('name_' + idx) ? 'is-invalid' : ''}`}
														onChange={e => this.subCategoryChangeHandler(e, idx)}
														disabled={formStatus.submitted}
													/>
												</div>
												<div className='row mb-3'>
													<div className='col-12'>
														<label>Require attachment</label>
														<input
															type="checkbox"
															name={'require_attachment'}
															checked={formData.subcategories[idx].require_attachment}
															placeholder="Subcategory type"
															onChange={e => this.subCategoryChangeHandler(e, idx)}
															disabled={formStatus.submitted}
															style={{ padding: "10px", marginLeft: '10px' }}
														/>
													</div>
												</div>
												<div className='row mb-3'>
													<div className='col-12'>
														{idx > 0 &&
															<button
																type="button"
																style={{ float: "right", display: 'inline-block' }}
																className="btn btn-danger btn-sm "
																onClick={e => this.removeSubcategoryHandler(e, idx)}
																disabled={formStatus.submitted}
															>
																<FontAwesomeIcon icon={faMinus} />
															</button>
														}
													</div>
												</div>
												<hr />
											</Fragment>
										})}

										<div className='row'>
											<div className='col-12'>
												<div style={{ float: 'right', display: 'inline-block' }}>
													<button
														type="button"
														className="btn btn-success btn-sm"
														onClick={e => this.addNewSubCategoryHandler(e)}
														disabled={(formData.subcategories[lastSubcategory]?.name === "") || formStatus.submitted}
													>
														<FontAwesomeIcon icon={faPlus} />
													</button>
												</div>
											</div>
										</div>
									</>
								}
							</form>
						</Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={this.closeCreateCategory} disabled={formStatus.submitted}>
								Close
							</Button>
							<Button variant="primary" onClick={this.submitNewCategory} disabled={formStatus.submitted}>
								Submit
							</Button>
						</Modal.Footer>
					</Modal>

					{/* Delete Modal */}
					<Modal
						show={modal.delete}
						size="lg"
						onHide={e => this.closeDeleteCategory(e)}
						backdrop="static"
						keyboard={false}
					>
						<Modal.Header closeButton={!formStatus.submitted}>
							<Modal.Title>Delete Category</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className='row'>
								<div className='col-12'>
									<p>
										Are you sure you want to delete {this.state.selected.delete?.name}
									</p>
								</div>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={this.closeDeleteCategory} disabled={formStatus.submitted}>
								Close
							</Button>
							<Button variant="primary" onClick={this.submitDeleteRequest} disabled={formStatus.submitted}>
								Submit
							</Button>
						</Modal.Footer>
					</Modal>
				</div>
				: <>Loading...</>
			}
		</>


	}
}


export default withOktaAuth(Categories);

